import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { File } from '@ionic-native/file';
import { AnalyticsProvider } from "../analytics/analytics";
// import { resolveDefinition } from '@angular/core/src/view/util';

declare var window: any;
/*
  Generated class for the CustomPluginProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
declare const greatdayplugin;

export interface GDIGeolocationCamera {
  camera: GDICamera,
  geolocation: GDIGeolocation
  cancelled: boolean
}

export interface GDICamera {
  nativeURL?: string,
  base64Image?: string,
  cancelled?: boolean
}
export interface GDIGeolocation {
  latitude?: any,
  longtitude?: any,
  cancelled?: boolean
}

export interface GDIRecruitment {
  results: string,
  cancelled: boolean
}

export class AttNativeResponseDefault {
  public response = {
    camera: {
      nativeURL: "",
      base64Image: ""
    },
    geolocation: {
      latitude: 0,
      longitude: 0
    },
    cancelled: false
  }
}

@Injectable()
export class CustomPluginProvider {

  constructor(
    public http: HttpClient,
    public file: File,
    private analyticsProvider: AnalyticsProvider) {

  }

  // default camera
  private quality = "75";
  private maxSize = "1920";

  // PLUGIN LAMA
  getGeolocation(): Promise<any> {
    return new Promise((resolve, reject) => {
      window.plugins.geolocationPlugin.show('geo', 'location', function (success) {
        resolve(success);
      }, function (err) {
        resolve(false);
      });
    })
  }

  getCamera(): Promise<any> {
    return new Promise((resolve, reject) => {
      window.plugins.camPlugin.show('camaera', 'long', function (success) {
        resolve(success);
      }, (err) => {
        resolve(err);
      });
    })
  }

  // PLUGIN BARU
  getGDCamera(fileName: string = 'img_gd'): Promise<GDIGeolocationCamera> {
    return new Promise((resolve, reject) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: 0,
          longitude: 0
        },
        cancelled: false
      }

      greatdayplugin.getCamera(fileName, this.quality, this.maxSize, async (success) => {
        const resolvedImageData = await this.file.resolveLocalFilesystemUrl("file://" + success);
        const filename = resolvedImageData.nativeURL.substring(resolvedImageData.nativeURL.lastIndexOf('/') + 1);
        const path = resolvedImageData.nativeURL.substring(0, resolvedImageData.nativeURL.lastIndexOf('/') + 1);
        const base64Image = await this.file.readAsDataURL(path, filename);

        data.camera.nativeURL = resolvedImageData.nativeURL;
        data.camera.base64Image = base64Image;
        resolve(data);
      }, (error) => {
        data.cancelled = true;
        resolve(data)
      })
    })
  }

  getCameraSwap(): Promise<GDICamera> {
    return new Promise((resolve, reject) => {
      let data = {
        nativeURL: "",
        base64Image: "",
        cancelled: false
      }

      greatdayplugin.getCameraSwap("img_gd", this.quality, this.maxSize, async (response) => {
        const resolvedImageData = await this.file.resolveLocalFilesystemUrl("file://" + response);
        const filename = resolvedImageData.nativeURL.substring(resolvedImageData.nativeURL.lastIndexOf('/') + 1);
        const path = resolvedImageData.nativeURL.substring(0, resolvedImageData.nativeURL.lastIndexOf('/') + 1);
        const base64Image = await this.file.readAsDataURL(path, filename);

        data.nativeURL = resolvedImageData.nativeURL;
        data.base64Image = base64Image;

        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  getGDGeolocation(): Promise<GDIGeolocationCamera> {
    return new Promise((resolve, reject) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: 0,
          longitude: 0
        },
        cancelled: false
      }

      greatdayplugin.getLocation((response) => {
        data.geolocation.latitude = response.latitude;
        data.geolocation.longitude = response.longitude;
        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  getGDGeolocationCamera(): Promise<GDIGeolocationCamera> {
    return new Promise((resolve, reject) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: "",
          longitude: ""
        },
        cancelled: false
      }

      greatdayplugin.getLocationCamera("img_gd", this.quality, this.maxSize, async (response) => {
        const resolvedImageData = await this.file.resolveLocalFilesystemUrl("file://" + response.path);
        const filename = resolvedImageData.nativeURL.substring(resolvedImageData.nativeURL.lastIndexOf('/') + 1);
        const path = resolvedImageData.nativeURL.substring(0, resolvedImageData.nativeURL.lastIndexOf('/') + 1);
        const base64Image = await this.file.readAsDataURL(path, filename);

        data.camera.nativeURL = resolvedImageData.nativeURL;
        data.camera.base64Image = base64Image;
        data.geolocation.latitude = response.latitude;
        data.geolocation.longitude = response.longitude;

        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  getLocationRadiusCamera(workLocation: string): Promise<GDIGeolocationCamera> {
    return new Promise((resolve, reject) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: "",
          longitude: ""
        },
        cancelled: false
      }

      greatdayplugin.getLocationRadiusCamera("img_gd", this.quality, this.maxSize, workLocation, async (response) => {
        const resolvedImageData = await this.file.resolveLocalFilesystemUrl("file://" + response.path);
        const filename = resolvedImageData.nativeURL.substring(resolvedImageData.nativeURL.lastIndexOf('/') + 1);
        const path = resolvedImageData.nativeURL.substring(0, resolvedImageData.nativeURL.lastIndexOf('/') + 1);
        const base64Image = await this.file.readAsDataURL(path, filename);

        data.camera.nativeURL = resolvedImageData.nativeURL;
        data.camera.base64Image = base64Image;
        data.geolocation.latitude = response.latitude;
        data.geolocation.longitude = response.longitude;
        resolve(data);
      }, (_) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  getCustomGeolocation(label1: string, label2: string, language: string, location: string): Promise<GDIGeolocationCamera> {
    return new Promise((resolve, reject) => {
      let data = {
        camera: {
          nativeURL: "",
          base64Image: ""
        },
        geolocation: {
          latitude: 0,
          longitude: 0
        },
        cancelled: false
      }

      greatdayplugin.getLocationLabelLanguageRadius(label1, label2, language, location, (response) => {
        data.geolocation.latitude = response.latitude;
        data.geolocation.longitude = response.longitude;
        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

  /** 
   * Open video recruitment plugin 
   * */
  getRecruitmentData(questions: string): Promise<GDIRecruitment> {
    return new Promise((resolve, reject) => {
      let data: GDIRecruitment = {
        results: null,
        cancelled: false
      }

      greatdayplugin.getRecruitmentData(questions, (response) => {
        data.results = response;
        resolve(data);
      }, (err) => {
        data.cancelled = true;
        resolve(data);
      });
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/custom-plugin/custom-plugin.ts